import React from 'react';
import { useTheme } from '@mui/material/styles';

import { Box, ProgressIndicator } from '@occc-app/design-system';

import { Punches } from './punches.component';
import { OfferMemberProgress, OfferProgressVariant } from '../in-progress-offers.types';

export type OfferProgressProps = {
  progress: OfferMemberProgress;
  variant: OfferProgressVariant;
};

export const OfferProgress = React.memo(
  ({ progress: { required, achieved }, variant }: OfferProgressProps) => {
    const theme = useTheme();

    return (
      <Box display='flex' alignSelf='stretch'>
        {variant === 'bar' && (
          <ProgressIndicator
            color={theme.palette.primary.main}
            total={required}
            current={achieved}
          />
        )}

        {variant === 'punches' && <Punches achieved={achieved} required={required} />}
      </Box>
    );
  },
);
